/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { DataEntrySource } from './data-entry-source';
import { DataQueryParameter } from './data-query-parameter';
import { DataQueryRelatedTo } from './data-query-related-to';
import { DataQueryTagDto } from './data-query-tag-dto';
import { FilterExpression } from './filter-expression';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';

/**
 * (tsType: DataQueryWithTagDtoWithRelations, schemaOptions: { includeRelations: true })
 */
export class DataQueryWithTagDtoWithRelations {
  creationInfo?: ActionInfo;
  criteria: null | FilterExpression;
  dataEntity: string;
  dataSource?: DataEntrySource;
  description?: null | NullableLocalizedValue;
  id?: string;
  isImplicit?: boolean;
  isParameterized?: boolean;
  name: LocalizedValue;
  parameters?: Array<DataQueryParameter>;
  relatedTo?: DataQueryRelatedTo;
  /** @deprecated */renderedCriteria?: string;
  specificationVersion: number;
  tag?: null | DataQueryTagDto;
  updateIdentifier: string;
  updateInfo?: ActionInfo;
  useInQuickFilter?: boolean;
  visibility: 0 | 1 | 2;
}
